import Splide from '@splidejs/splide';
import '@splidejs/splide/css/core';
import '../scss/timeline.scss';
import { Localize } from './modules/utilities/localize';

const timelineSlider = Array.from(document.querySelectorAll('.js-timeline-slider'));

document.addEventListener('DOMContentLoaded', () => {
  if (timelineSlider) {
    timelineSlider.forEach((timeline) => {
      const timelineSlider = new Splide(timeline, {
        type: 'slide',
        rewind: false,
        width: '100%',
        height: 'max-content',
        start: 0,
        perPage: 1,
        arrows: true,
        pagination: false,
        autoplay: true,
        pauseOnHover: true,
        pauseOnFocus: true,
        lazyLoad: 'nearby',
        preloadPages: 2,
        keyboard: true,
        direction: 'ltr',
        breakpoints: {
          480: {
            perPage: 1,
            height: 'max-content',
          },
        },
        i18n: {
          'prev': `${Localize('element.label.timeline.prev', 'Previous')}`,
          'next': `${Localize('element.label.timeline.next', 'Next')}`,
          'first': `${Localize('element.label.timeline.first', 'First')}`,
          'last': `${Localize('element.label.timeline.last', 'Last')}`,
          'slideX': `${Localize('element.label.timeline.slideX', 'Slide')}`,
          'pageX': `${Localize('element.label.timeline.pageX', 'Page')}`,
          'play': `${Localize('element.label.timeline.play', 'Play')}`,
          'pause': `${Localize('element.label.timeline.pause', 'Pause')}`,
          'carousel': `${Localize('element.label.timeline.carousel', 'Carousel')}`,
          'select': `${Localize('element.label.timeline.select', 'Select to show')}`,
          'slide': `${Localize('element.label.timeline.slide', 'Slide')}`,
          'slideLabel': `${Localize('element.label.timeline.slideLabel', 'Slide %s of %s')}`,
        }
      });

      const timelineImageSlider = new Splide('.js-timeline-image-slider', {
        arrows: false,
        cover: true,
        clones: 0,
        drag: false,
        fixedWidth: 68,
        fixedHeight: 68,
        flickPower: 600,
        flickMaxPages: 1,
        focus: 2,
        height: 218,
        isNavigation: true,
        pagination: false,
        perMove: 1,
        perPage: 1,
        rewind: false,
        trimSpace: true,
        waitForTransition: true,
        wheel: true,
        i18n: {
          'prev': `${Localize('element.label.timeline.prev', 'Previous')}`,
          'next': `${Localize('element.label.timeline.next', 'Next')}`,
          'first': `${Localize('element.label.timeline.first', 'First')}`,
          'last': `${Localize('element.label.timeline.last', 'Last')}`,
          'slideX': `${Localize('element.label.timeline.slideX', 'Slide')}`,
          'pageX': `${Localize('element.label.timeline.pageX', 'Page')}`,
          'play': `${Localize('element.label.timeline.play', 'Play')}`,
          'pause': `${Localize('element.label.timeline.pause', 'Pause')}`,
          'carousel': `${Localize('element.label.timeline.carousel', 'Carousel')}`,
          'select': `${Localize('element.label.timeline.select', 'Select to show')}`,
          'slide': `${Localize('element.label.timeline.slide', 'Slide')}`,
          'slideLabel': `${Localize('element.label.timeline.slideLabel', 'Slide %s of %s')}`,
        }
      });

      timelineSlider.sync(timelineImageSlider);
      timelineSlider.mount();
      timelineImageSlider.mount();
    });
  }
});
